<template>
    <div>     
        <div style=" display:flex; width:100%; background:#fff;line-height:30px;border-bottom:2px solid #389;padding-top:3px">
            <div style="min-width:1100px;display:flex">
                <i class="iconfont icon-xinzeng" style="color:#409EFF;font-size:14px;margin-right:5px;margin-left:8px;"></i>
                <el-link :disabled="addBool" @click="addRec" :underline="false" ><span style="font-size:12px;margin-right:15px;">{{ $LANG('0095', '新增记录') }}</span></el-link>
                <el-select v-model="selparam"  :placeholder="$LANG('1675', '请选择列名')" filterable  size="small" style="width:150px;margin-left:20px; ">
                    <span v-for="item in tabArr" :key='item.key'>
                        <el-option :label="$translate.getColTitle(item, $store.state.lang)" :value="item.key" v-if="item.thide=='N'"></el-option>
                    </span>
                </el-select>
                <el-input :placeholder="$LANG('1692', '请输入查询值')" v-model="txtparam" size="small" @keyup.enter.native="qryTabData" style="width:310px;margin-left:2px;height:30px;  ">
                    <el-select v-model="oper" slot="prepend"   style="width:100px; " >
                        <span v-for="item in operArr" :key='item.IDSEQ'>
                            <el-option :label="item.CNAME" :value="item.SUBNO" ></el-option>
                        </span>
                    </el-select>
                    <el-button size="small" slot="append" icon="el-icon-search" @click="qryTabData" style="color:#409eff"></el-button>
                </el-input> 
                <i class="iconfont icon-ziyuan" style="color:#409EFF;font-size:14px;margin:0 5px 0 15px;"></i>
                <el-link @click="openFieldSettingsDialog().catch(() => {})" :underline="false"><span style="font-size:12px;margin-right:15px;">{{ $LANG('0683', '字段设置') }}</span></el-link>

                <!-- <el-select v-model="selparam2"  placeholder="请选择列名" clearable size="small" style="width:150px; ">
                    <span v-for="item in tabArr" :key='item.key'>
                        <el-option :label="item.title" :value="item.key" v-if="item.thide=='N'"></el-option>
                    </span>
                </el-select>
                <el-input placeholder="请输入查询值" v-model="txtparam2" size="small" @keyup.enter.native="qryTabData" style="width:310px;margin-left:2px;height:30px;  ">
                    <el-select v-model="oper2" slot="prepend"   style="width:100px; " >
                        <span v-for="item in operArr" :key='item.IDSEQ'>
                            <el-option :label="item.CNAME" :value="item.SUBNO" ></el-option>
                        </span>
                    </el-select>
                    <el-button size="small" slot="append" icon="el-icon-search" @click="qryTabData" style="color:#409eff"></el-button>
                </el-input>  -->
            </div>
        </div> 
        <ve-table :columns="vueCol"
                :table-data="tabData"
                :columnHiddenOption="columnHiddenOption"
                :border-around="true"
                :border-x="true"
                :border-y="true"
                :fixed-header="true"
                row-key-field-name="IDSEQ"
                :row-style-option="rowStyleOption"
                :cell-style-option="cellStyleOption"
                :event-custom-option="eventCustomOption"
                :max-height="tabHeight"
                :virtual-scroll-option="virtualScrollOption"
                :column-width-resize-option="columnWidthResizeOption"
                :clipboardOption="{copy:true,paste:false,cut:false,delete:false}"
                :cellSelectionOption="{enable: false}"
                id="unit_mgt_load"
                ref="tabref">
        </ve-table>
 
        <el-dialog class="pub_dialog" v-dialogDrag  :visible.sync="addWin" width="1200px" :close-on-press-escape="false" :close-on-click-modal="false" append-to-body top="4vh">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:36px;height:36px;font-size:15px;padding-left:5px;"><i class="iconfont icon-xuanze" style="margin-right:5px"></i>{{$route.meta.title}} ：{{ $LANG('0109', '明细资料') }}</span>
            </div> 
            <div style=" overflow-y:auto">
                <Form :model="perRow" :label-width="120"  label-position="right" inline  :rules="ruleValidate">  
                    <span v-for="(item,index) in tabArr" :key="index" >
                        <FormItem  :label="$translate.getColTitle(item, $store.state.lang)"  :class=" 'item-width'" :prop="item.key"  v-if="item.fhide==='N'">
                            <el-date-picker   :disabled="saveFlag" type="date"  v-if="item.edcss==='date'" v-model="perRow[item.key]" clearable value-format="yyyy-MM-dd" style="width:100%" ></el-date-picker>   
  
                            <el-input type="number" @keydown.native="e=>e.returnValue=(['e','E','+'].includes(e.key))?false:e.returnValue"    v-else-if="item.disabled=='N'&&item.edcss=='number'"  v-model="perRow[item.key]" style="width:100%"> </el-input> 
                            <el-checkbox   border v-else-if="item.edcss==='checkbox'" true-label="Y"  false-label="N" v-model="perRow[item.key]" style="width:100%"></el-checkbox> 
                            <el-select filterable :disabled="saveFlag" v-else-if="item.edcss==='select'" v-model="perRow[item.key]"   style="width:100%">
                                <el-option v-for="(item,index) in comboArr[item.key]" :key="index" :label="item.CNAME" :value="item.CODE"></el-option>
                            </el-select>

                            <el-input   type="text" v-else :disabled="item.disabled==='Y'?true:false||saveFlag "  v-model="perRow[item.key]"></el-input>
                        </FormItem>
                    </span>
                </Form>

            </div>
            <div style="height:40px;line-height:30px;border-top:2px solid #ccc;padding-top:4px; ">   
                <span style="float:right">
 
                    <el-button type="info" size="small" icon="iconfont icon-shanchu"  @click="addWin=false" style="margin-right:50px;">{{ $LANG('0132', '取消') }}</el-button>
                    <el-button type="primary" size="small" icon="iconfont icon-baocun"  :disabled="saveFlag?true:false" @click="saveRec" style="margin-right:10px;">{{ $LANG('0130', '保存') }}</el-button>
                </span>
            </div>
        </el-dialog>
        <!-- 提示框 -->
        <el-dialog v-dialogDrag :visible.sync="promptWin"  width="450px" :close-on-click-modal="false" :close-on-press-escape="false" append-to-body>
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">{{ $LANG('1442', '提示') }}</span>
            </div>
            <div style="line-height:30px;display:flex">
                <div style="width:40px; "><i class="iconfont icon-tishi1" style="color:#5cadff;font-size:36px"></i></div>
                <div style="font-size:12px;line-height:30px; ">{{prompt}}</div>
            </div>
            <span slot="footer"  >
                <el-button type="primary" size="small" @click="promptWin = false">{{ $LANG('1638', '确定') }}</el-button>
            </span>
        </el-dialog>
        <VeColumnConfigDialog
            :visible="fieldSettingDialog.visible"
            :rows="fieldSettingDialog.rows"
            :loading="fieldSettingDialog.loading"
            :error="fieldSettingDialog.error"
            :locked-field-keys="fieldSettingDialog.lockedFieldKeys"
            :drag-group-field="fieldSettingDialog.dragGroupField"
            :language="$store.state.lang"
            @update:visible="fieldSettingDialog.visible = $event"
            @change="updateFieldSettingsDraft"
            @confirm="saveFieldSettingsDialog"
            @reset="resetFieldSettingsDialog"
            @close="closeFieldSettingsDialog"
        />
 
    </div>
</template>
<script>
 
import { getTabColOrData,getBaseData } from '../../api/user';
import {getDate} from '../../api/Select' 
import createVeTableFieldSettingMixin from '@/utils/veTableFieldSettingMixin'
import VeColumnConfigDialog from '@/components/VeTable/VeColumnConfigDialog.vue'
//局部注册
export default {
    name:"unit_data",
    mixins: [
        createVeTableFieldSettingMixin({
            settingFormId: '411421',
            fieldIdseq: '411421',
            fieldLstseq: '1',
            mainColumnKey: 'tabArr',
            tableColumnKey: 'vueCol',
            initColumnKey: 'initCol',
            tableRef: 'tabref',
            generatedFixedColumnKeys: ['rownum', 'oper'],
        })
    ],
    components: {
        VeColumnConfigDialog,
    },
    data () {
        return {
            addWin:false,
            perFlag:'create',
            mthArr:[],
            saveFlag:false,
            promptWin:false,
            prompt:'',
            stfgCss:'',
            perWin:false,
            stfgColor:'',
            perRow:{},
            menuList: [],
            openName:[], //模块ID集合
            cpWin:false,
            frmth:'',
            tomth:'',
            active:'', //二级菜单选中标志
 
            disabled:false, //新增权限制
 
            ruleValidate:{},
 
            tabData:[], //表数据
            tabArr:[], //表列 
            initCol:[],
            vueCol:[],
            v_row:{},
            v_inputrow:{},
            columnHiddenOption: {
                defaultHiddenColumnKeys: [],
            },
            rowStyleOption: { clickHighlight: true },
            cellStyleOption: {
                headerCellClass: () => 'table-head-cell-class',
                bodyCellClass: () => 'table-body-cell-class1',
            },
            eventCustomOption: {
                bodyRowEvents: ({ row }) => ({
                    click: () => this.rowClick(row),
                }),
            },
            virtualScrollOption: { enable: false },
            operArr:[],           
            comboArr:{},
            oper:'like',
            txtparam:'',
            selparam:'BSUNITNM',
            oper2:'like',
            txtparam2:'',
            selparam2:'',
            delArr:[],
            rowIndex:'-1',
            queryRequestId:0,
            v_url:'xuper_auth/getTableRecMany', //api请求路径
            v_formurl:'xuper_auth/getFormGroup', 
            v_username:this.$cookies.get('v_telno'), //api 请求用户
            
            v_corpid:this.$cookies.get('v_corpid') ,//api 请求密码
            v_admin:this.$cookies.get('v_admin') ,//api 请求密码
            dataCount:0,
            rowSize:20,
            goPage:'',
            notNull:[],
            current:1,
            imgSrc:'',
            stfgBool:true,
            addBool:false, //新增,为true时--禁止
            editBool:false, //编辑,为true时--禁止
            delBool:false, //删除 ,为true时--禁止
            cfmBool:false, //审核 ,为true时--禁止
            cancelBool:false, //作废 ,为true时--禁止
 
        }
    },
    mounted () { 
        //操作符
        getBaseData('xuper_auth/getBaseData','PARENTNO','15995','','','v_sys_base','').then(res=>{
            this.operArr =res.result
        })
        getBaseData('xuper_auth/getBaseData','','','','','V_YRMTH','').then(res=>{
            this.mthArr =res.result
        })
        //用户表单新增、编辑、审核、作废权限  
        getBaseData(this.v_url,'userno',this.v_username,'frmidseq','411421','v_sys_user_priv','').then(res=>{           
            if (this.v_admin==='N') { //表示有权限控制
                let row =res.result[0]
                if (row.ISADD==='N'){ //新增
                    this.addBool=true
                }if (row.ISUPD==='N'){ //修改
                    this.editBool=true
                }if (row.ISDEL==='N'){ //删除
                    this.delBool=true
                }if (row.ISCFM==='N'){ //审核
                    this.cfmBool=true
                }if (row.ISCANCEL==='N'){ //作废
                    this.cancelBool=true
                }
            }
        })  
        //表单所以下拦框动态赋值
        this.comSelect()
 
        //动态生成表单验证规则
        getTabColOrData(this.v_url,'v_sys_form_fld','idseq','411421','LSTSEQ','1','NOTNULL','Y').then((res) => {
            let ruleObj={}
            let ruleVal=[]
            this.notNull = res.result
            res.result.forEach(item => {
                let v_fldnm =this.$translate.getColTitle(item, this.$store.state.lang)
                let obj1={required:true,message:v_fldnm+this.$LANG('2051', '不能为空')}
                ruleVal =[]
                ruleVal.push(obj1)
                ruleObj[item.FLDNO]=ruleVal                  
            });
            this.ruleValidate =ruleObj
        })
 
    },
    computed: {
        editHeight: function() {
            return (window.innerHeight - 300) + 'px';
        }, 
        tabHeight: function() {
            return (window.innerHeight - 130) + 'px';
        }, 
    },
    created () {       
        if (this.v_username){ 
            //查询数据
            this.qryTabData()
            this.getTabField() //表列字段          
        }else{
            let routeUrl = this.$router.resolve({
                path: '/login',
                query: {},
            });
            window.open(routeUrl.href, '_self');
        }
    },
    watch: {
 
    },
    methods: {
        escapeQueryValue(value){
            return String(value).replace(/'/g, "''")
        },
        buildHeaderQueryCondition(){
            return (this.initCol || []).reduce((cond, item) => {
                const key = item.key
                const value = this.v_row[key]
                if (!key || !/^[A-Za-z0-9_]+$/.test(key) || value === '' || value === null || value === undefined) return cond
                const edcss = String(item.EDCSS || '').toLowerCase()
                const oper = this.v_row[`#OPER${key}`] || (['number', 'date', 'select', 'checkbox'].includes(edcss) ? '=' : 'like')
                if (edcss === 'number') {
                    if (!/^-?\d+(\.\d+)?$/.test(String(value).trim())) return cond
                    return `${cond} and ${key}${oper}${String(value).trim()}`
                }
                const escaped = this.escapeQueryValue(String(value).trim())
                if (edcss === 'checkbox' || edcss === 'select') return `${cond} and ${key}='${escaped}'`
                if (edcss === 'date') return `${cond} and ${key}${oper}'${escaped}'`
                return oper === 'like'
                    ? `${cond} and upper(${key}) like upper('%${escaped}%')`
                    : `${cond} and ${key}${oper}'${escaped}'`
            }, '')
        },
        inputChg(event, key){
            const value = event && event.target ? event.target.value : event
            this.$set(this.v_inputrow, key, value)
            this.$set(this.v_row, key, value)
        },
        enterDown(event){
            if (event && (event.key === 'Enter' || event.keyCode === 13)) this.qryTabData()
        },
        rowShow(){
            this.v_row = {}
            this.v_inputrow = {}
            this.qryTabData()
        },
        headStyle({row,column}){
            if (column.property=='RATIO' ){
                return 'color:red;height:28px'
            }
        },
        //表行点击事件
        rowClick(row){
            if (row['STFGNM']==='审核')  {  
                this.stfgColor='color:green'
                this.stfgCss='icon-yishenhe1'
            }else if (row['STFGNM']==='作废')  {  
                this.stfgColor='color:red'
                this.stfgCss='icon-yizuofei'
            }else{
                this.stfgColor='color:gray'
                this.stfgCss='icon-weishenhe3'
            }
 
        },
        //动态赋值下拉框
        comSelect(){  
            this.$axios({
                method:'post', 
                url: 'xuper_auth/getBaseData' ,
                data:{p_table:'v_sys_form_fld',p_key:'idseq',p_value:'411421',p_key2:'lstseq',p_value2:'1',p_key3:'edcss',p_value3:'select'},
            }).then(res =>{
                if (res.result.length>0){
                    for(let k=0;k<res.result.length;k++){
                        getBaseData('xuper_auth/getBaseData','parentno',res.result[k].COMBO ,'','','v_sys_base','').then(res2=>{
                            this.comboArr[res.result[k].FLDNO] =res2.result
                        })
                    }
                }
            })  
        },
        //保存记录
        saveRec(){
            var vm =this 
            this.notNull.some(item=>{  //forEach 没找到跳出循环，some：return true 跳出lop ,every：return false 跳出
                if (!this.perRow[item.FLDNO] ){
                    this.stfgBool =false 
                    this.promptWin=true
                    this.prompt=item.FLDNM+'不能为空'
                    return true
                }else{
                    this.stfgBool =true  
                }
            })
            //发起保存请求   
            if (this.stfgBool) {  
                let obj_ ={}      
                Object.assign(obj_,vm.perRow,{ 'CORPID':this.v_corpid}) 
                this.$axios({
                    method: 'post',
                    url:'xuper_auth/formOneSave',
                    data: {p_json:JSON.stringify(obj_), p_table:'bs_unit',frmid:'411421'},
                }).then(res=>{      
                    if(res.code ==='200')  {  
                        vm.addWin =false   
                        this.qryTabData()
                    }else{
                        if (res.result.indexOf('ORA-00001')){
                            this.prompt='已存在相同记录，请核查'
                        }else{
                            this.prompt=res.result
                        }
                        this.promptWin=true                       
                    }        
                }) 
            }
        },
        //状态审核
        recSet(row,val){
            let stfg_ =val==='Y'?'审核':val==='N'?'弃审':'作废'
            this.$confirm('你确定要'+stfg_+'此行记录吗','提示',{
                confirmButtonText: '确定',
                cancelButtonText:'取消',
                customClass:'messageBox',
                showClose:false,
                closeOnClickModal:false,
                closeOnPressEscape:false,
                type:'info',
            }).then(()=>{
                var vm=this;
                let cond_=''
                if (val==='Y'){
                    cond_=' set stfg=\''+val+'\',cfmdttm=\''+getDate('date')+'\' '
                }else{
                    cond_=' set stfg=\''+val+'\',cfmdttm=null ' 
                }
                this.$axios({
                    method: 'post',
                    url:'xuper_auth/updateRec',
                    data: {p_key:'idseq',p_value:row.IDSEQ ,p_table:'bs_unit',p_cond:cond_ },
                }).then(res=>{      
                    if(res.code =='200')  {           
                        vm.qryTabData()     
                    }else{
                        this.promptWin=true
                        this.prompt=res.message
                    }        
                }) 
                 
            }).catch(()=>{})
        },
        //单位明细
        getUnitList(cond){
            //获取所有产品记录且初始化分页记录         
            const requestId = ++this.queryRequestId
            this.$axios({   
                method: 'post',
                url:'xuper_auth/getBaseData',
                data: {p_key2:'corpid', p_value2:this.v_corpid,p_cond:cond+ ' order by '+this.selparam+' desc',p_table:'V_BS_unit'},
            }).then(res=>{ 
                if (requestId !== this.queryRequestId) return
                if (res.code==='200'){
                    this.tabData =res.result
 
                }else{
                    this.promptWin=true
                    this.prompt=res.result
                }
                this.$nextTick(() => {
                    const table = this.$refs.tabref
                    if (table && typeof table.doLayout === 'function') table.doLayout()
                })
            }).catch((error) => {
                if (requestId === this.queryRequestId) {
                    this.promptWin=true
                    this.prompt=error.message || this.$LANG('1641', '查询失败')
                }
            }) 
        },
 
        editRec(row,val){

            this.saveFlag=false
            this.rowClick(row)
            this.perRow =JSON.parse(JSON.stringify(row))
            this.addWin=true           
        },
        getRowKey(row){
            return row.IDSEQ
        },
        //查询
        qryTabData(){
            let cond_=this.buildHeaderQueryCondition()
            if (this.selparam && this.txtparam !== ''){ //列1
                const selectedField = this.tabArr.find(item => item.key === this.selparam)
                if (!selectedField) return
                const value = this.escapeQueryValue(this.txtparam)
                if (this.oper==='like'){
                    cond_=cond_+' and upper('+selectedField.key+") like upper('%" + value+"%')"
                }else{
                    cond_=cond_+' and '+selectedField.key +this.oper+'\''+value+'\''
                }
            }
 
            this.getUnitList( cond_)
             
        },
        //新增 
        addRec(){
 
            this.addWin =true
            this.stfgCss='icon-weishenhe3'
            this.perRow={}
            this.saveFlag=false
     
        },
        //删除记录
        delRec(row){
            this.$confirm('你确定要删除此行记录吗','提示',{
                confirmButtonText: '确定',
                cancelButtonText:'取消',
                customClass:'messageBox',
                showClose:false,
                closeOnClickModal:false,
                closeOnPressEscape:false,
                type:'info',
            }).then(()=>{
                //发起删除请求
                var vm=this
                this.$axios({
                    method: 'post',
                    url:'xuper_auth/delTabRec',
                    data: {p_key:'idseq',p_value:row.IDSEQ,p_table:'bs_unit'},
                }).then(res=>{      
                    if(res.code =='200')  {           
                        this.qryTabData()  
                    }else{
                        this.promptWin=true
                        this.prompt=res.result
                    }        
                })     
            }).catch(()=>{})
        },
 
 
        //获取表列字段
        getTabField(){
            let vm =this
            getTabColOrData(this.v_url,'v_sys_form_fld','idseq','411421','lstseq','1','','',' order by sortby,lstseq').then((res) => {
                vm.initCol =res.result
                return vm.loadInitialFieldSettings().then(() => {
                    const fieldRows =vm.sortFieldRows(vm.initCol)
                    vm.tabArr =[]
                    vm.vueCol =[]
                    fieldRows.forEach(item => {
                        vm.tabArr.push({
                            title: vm.$translate.getColTitle(item, vm.$store.state.lang),
                            key: item.key,
                            align: item.align,
                            width: item.width,
                            thide: item.THIDE,
                            fhide: item.FHIDE,
                            edcss: item.EDCSS,
                            disabled: item.DISABLED,
                        })
                        if (item.THIDE !== 'N') return
                        vm.vueCol.push({
                            field: item.key,
                            key: item.key,
                            title: vm.$translate.getColTitle(item, vm.$store.state.lang),
                            type: item.EDCSS === 'checkbox' ? 'check' : item.EDCSS,
                            align: item.align,
                            width: Number(item.width) || 120,
                            sortable: item.key !== 'RN' && item.EDCSS !== 'checkbox',
                            ellipsis: { showTitle: true },
                            renderHeaderCell: ({ column }) => (
                                <div>
                                    <div style={Object.assign({ marginTop: '3px', display: 'flex', whiteSpace: 'nowrap', fontSize: '12px', color: '#03274b', fontWeight: 700 }, item.key === 'RATIO' ? { color: 'red' } : {})}>{column.title}</div>
                                    {String(item.EDCSS || '').toLowerCase() === 'number'
                                        ? <div style="display:flex">
                                            <select style="width:55px;background:white;height:28px;margin-top:1px" value={vm.v_inputrow[`#OPER${item.key}`] || '='} on-change={(event) => vm.inputChg(event, `#OPER${item.key}`)}>
                                                <option value="=">=</option><option value=">">&gt;</option><option value="<">&lt;</option><option value="!=">!=</option>
                                            </select>
                                            <input value={vm.v_inputrow[item.key]} on-keydown={vm.enterDown} on-input={(event) => vm.inputChg(event, item.key)} style="padding:0;margin-top:1px;width:100%;height:28px" />
                                        </div>
                                        : String(item.EDCSS || '').toLowerCase() === 'select'
                                            ? <el-select size="mini" clearable style="width:100%;height:28px;margin-top:1px" value={vm.v_row[item.key]} on-input={(value) => vm.inputChg(value, item.key)} on-change={vm.qryTabData}>
                                                {(vm.comboArr[item.key] || []).map(option => <el-option key={option.CODE} value={option.CODE} label={option.CNAME}></el-option>)}
                                            </el-select>
                                            : String(item.EDCSS || '').toLowerCase() === 'checkbox'
                                            ? <el-select size="mini" clearable style="width:100%;height:28px;margin-top:1px" value={vm.v_row[item.key]} on-input={(value) => vm.inputChg(value, item.key)} on-change={vm.qryTabData}>
                                                <el-option value="Y" label={vm.$LANG('2047', '是')}></el-option>
                                                <el-option value="N" label={vm.$LANG('2044', '否')}></el-option>
                                            </el-select>
                                            : <div style="display:flex"><input type={String(item.EDCSS || '').toLowerCase() === 'date' ? 'date' : 'text'} disabled={String(item.EDCSS || '').toLowerCase() === 'image'} value={vm.v_inputrow[item.key]} on-keydown={vm.enterDown} on-input={(event) => vm.inputChg(event, item.key)} style="padding:0;margin-top:1px;width:100%;height:28px" /></div>}
                                </div>
                            ),
                            renderBodyCell: ({row}) => item.EDCSS === 'checkbox'
                                ? <el-checkbox disabled true-label="Y" false-label="N" v-model={row[item.key]}></el-checkbox>
                                : row[item.key],
                        })
                    })
                    vm.vueCol.unshift({
                        field: 'index',
                        key: 'rownum',
                        title: vm.$LANG('0310', '序号'),
                        width: 60,
                        align: 'center',
                        fixed: 'left',
                        renderBodyCell: ({rowIndex}) => rowIndex + 1,
                        renderHeaderCell: ({ column }) => (
                            <div>
                                <div style="margin-top:3px">{column.title}</div>
                                <el-link on-click={vm.rowShow} style="font-size:12px;color:#404eff;height:30px">
                                    <el-tooltip content={vm.$LANG('0852', '清除条件')} effect="light"><i class="iconfont icon-shanchu1"></i></el-tooltip>
                                </el-link>
                            </div>
                        ),
                    })
                    vm.vueCol.push({
                        field: 'oper0',
                        key: 'oper',
                        title: vm.$LANG('0330', '操作'),
                        width: 130,
                        align: 'center',
                        fixed: 'right',
                        renderBodyCell: ({row}) => (
                            <div>
                                <i class="iconfont icon-bianji" style="color:#409EFF;font-size:12px;margin-right:5px;"></i>
                                <el-link disabled={this.editBool} on-click={() => this.editRec(row, 'N')} underline={false}>
                                    <span style="font-size:12px;margin-right:5px;">{this.$LANG('1639', '编辑')}</span>
                                </el-link>
                                <i class="iconfont icon-shanchu" style="color:#409EFF;font-size:12px;margin-right:5px;"></i>
                                <el-link disabled={this.cancelBool} on-click={() => this.delRec(row)} underline={false}>
                                    <span style="font-size:12px;">{this.$LANG('0131', '删除')}</span>
                                </el-link>
                            </div>
                        ),
                    })
                    vm.applyFieldSettingRows()
                    return res
                })
            })
 
        }
    }
}
</script>
<style scoped lang="less">
 
    .pub_dialog {
        display: flex;
        justify-content: center;
        align-items: Center;
        overflow: hidden;
        .el-dialog {
            margin: 1px auto !important;
            height: 90%;
            overflow: hidden;
            .el-dialog__body {
                position: absolute;
                left: 0;
                top: 54px;
                bottom: 0;
                right: 0;
                padding: 0;
                z-index: 1;
                overflow: hidden;
                overflow-y: auto;
            }
        }
    }
    .item-width  {
        width: 48%;
        height:25px;
    }
    .active { 
        color:#D200D2; 
    } 
    .wraper{
        width:1250px;
        margin:1px auto;
    }
</style>
<style lang="less">
    .custom-table-border .el-table__body td, .custom-table-border .el-table__header th {
        border-color: rgb(184, 181, 181);
        border-width: 1px;
    }
    .el-table {
        th {
            padding: 0 ;
        }
        thead{
            height: 15px !important;
            color:rgb(128,128, 128);
            font-size:12px;
        }
        td {
            padding: 5px ;
            font-size:11px;
        }   
    }
    .el-table__body {
        width: 100%;
        // 使表格兼容safari，不错位
        table-layout: fixed !important;
    }
 
    .el-checkbox__input.is-disabled.is-checked .el-checkbox__inner::after{
        border-color :#3d77eb
    }
    .el-checkbox__input.is-disabled+span.el-checkbox__label{
        color:#3d77eb
    }
    .el-dialog__body{
        padding: 10px;
    }
    .el-dialog__header{
        padding: 0px;
    }
    .el-dialog__footer{
        padding: 5px;
        border-top:1px solid #ccc;
    } 
    // .el-dialog__headerbtn{font-size: 20px; background:white;top:5px !important;}
    .messageBox .el-message-box__content{
        border-top: 1px solid #EBEEF5;
        height: 50px;
    }
    .el-message-box__message p{
        line-height: 30px;
    }
    .messageBox .el-message-box__btns{
        padding: 20px 15px 0;
    }
    .messageBox .el-message-box__header{
        background:#409eff;
    }
    .messageBox .el-message-box__title{
        color:white ;
        font-size:14px;
    }
</style>
